import React from 'react'
import cx from 'classnames'
import { CoverImage } from '../image'
import { DFBIButton } from '../button'
import styles from './body-content.module.scss'

export default function Body({
  logo,
  heading,
  subheading,
  image,
  caption,
  children,
  asset,
  button,
}) {
  return (
    <article className="container container--grid">
      <header className={cx(styles.header, 'child-my-0', 'container__row')}>
        <h2 className={cx(styles.header__heading, 'type-d-p-xxl')}>
          {heading}
        </h2>
        <div className={cx(styles.header__meta, 'child-my-0')}>
          <img className={styles.header__logo} {...logo} />
        </div>
      </header>
      <figure className={styles.figure}>
        <CoverImage
          className={styles.figure__image}
          ratio={390 / 508}
          {...image}
        />
        <figcaption className={cx(styles.figure__caption, 'type-dfbi-label')}>
          {caption}
        </figcaption>
      </figure>
      <div className={styles.content}>
        <h3 className={cx(styles.content__heading, 'type-dfbi-label')}>
          {subheading}
        </h3>
        <div
          className="wysiwyg child-my-0"
          dangerouslySetInnerHTML={{ __html: children }}
        />
        {!asset ? null : (
          <footer>
            <DFBIButton max download fill href={asset}>
              {button}
            </DFBIButton>
          </footer>
        )}
      </div>
    </article>
  )
}
